import { render, staticRenderFns } from "./VerifyIdentity.vue?vue&type=template&id=3a8015ab&"
import script from "./VerifyIdentity.vue?vue&type=script&lang=js&"
export * from "./VerifyIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8015ab')) {
      api.createRecord('3a8015ab', component.options)
    } else {
      api.reload('3a8015ab', component.options)
    }
    module.hot.accept("./VerifyIdentity.vue?vue&type=template&id=3a8015ab&", function () {
      api.rerender('3a8015ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/eSign/components/VerifyIdentity.vue"
export default component.exports